import { createClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

if (!url || !anon) {
  throw new Error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY in .env.local');
}

// `lock` override bypasses navigator.locks coordination so a stuck lock in a
// closed tab / crashed extension can't leave getSession() hanging forever.
export const supabase = createClient(url, anon, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    lock: async (_name, _acquireTimeout, fn) => fn(),
  },
});

export async function waitForSession(retries = 5, delayMs = 150) {
  let lastError: Error | null = null;

  for (let attempt = 0; attempt < retries; attempt += 1) {
    const { data, error } = await supabase.auth.getSession();
    if (error) {
      lastError = error;
    }
    if (data.session) {
      return data.session;
    }
    if (attempt < retries - 1) {
      await new Promise((resolve) => window.setTimeout(resolve, delayMs));
    }
  }

  throw lastError ?? new Error('Your session is still starting. Please try again.');
}

export default supabase;
